import React from "react";
import clsx from "clsx";
import { FlexColumn } from "@/components/Flex";
import { themeColors } from "@/utils/themeColors";

const SidebarBody = ({
    className,
    children,
    style,
    ...props
}: { children?: React.ReactNode; style?: React.CSSProperties } & React.ComponentProps<typeof FlexColumn>) => {
    return (
        <FlexColumn
            className={clsx(className)}
            style={{
                position: "relative",
                flexShrink: 0,
                height: "100%",
                padding: "2rem 1.75rem 3rem 1.75rem",
                backgroundColor: themeColors.background,
                ...style,
            }}
            {...props}>
            {children}
        </FlexColumn>
    );
};

export default SidebarBody;
